// src/components/store/QuickCartComponents/Badge.jsx
import React from "react";

// Componente Badge mejorado para 3 zonas
export const Badge = ({ text, bgColor, textColor, zone }) => {
  // Si se pasa una zona, usar colores automáticos
  const getZoneColors = (zoneNumber) => {
    switch (zoneNumber) {
      case 1:
        return { bg: "bg-green-200", text: "text-green-700" };
      default:
        return { bg: "bg-gray-200", text: "text-gray-700" };
    }
  };

  const colors = zone ? getZoneColors(zone) : { bg: bgColor, text: textColor };

  return (
    <div
      className={`w-fit px-2 py-1 md:py-0 ${colors.bg} rounded-md justify-center items-center inline-flex`}
    >
      <div
        className={`${colors.text} text-sm md:text-base font-normal leading-none text-nowrap`}
      >
        {text}
      </div>
    </div>
  );
};

export default Badge;